<template>
  <div class="page page-finishings">
    <div class="page__wrap" data-animate="page-wrap">
      <div class="row-1 page-finishings-header p-top-3 m-bot-5">
        <PagesFinishingsHeader :header="finishings.generalHeader?.[0]" />
        <ListingFilters
          :families="familiesForFilters"
          @selected="onFilterSelected"
        />
      </div>

      <!-- Finishings -->
      <PagesFinishingsList
        class="row-1 m-top-3"
        :finishings="list"
        :class="{
          'p-bot-3': count <= limit,
        }"
      />

      <WidgetPaginationListing
        v-if="count > limit"
        class="row-1 flex --justify-center m-top-5 p-bot-3"
        :itemPerPage="limit"
        :total="count"
      />
    </div>
  </div>
</template>

<script setup>
import { useCraftStore } from '@/store/craft.js'

// Importa le query GraphQL
import queries from '@/graphql/craft/queries/index.js'

import finishesFilters from '@/bucket/finishings-filters.js'

import {
  onBeforeEnter,
  onEnter,
  onLeave,
} from '~/assets/js/page-transitions/listing.js'

definePageMeta({
  layout: 'default',
  pageTransition: {
    onBeforeEnter: (el) => {
      onBeforeEnter(el)
    },
    onEnter: async (el, done) => {
      const tl = onEnter(el)
      await tl.delay(0.5).play()
      done()
    },
    onLeave: async (el, done) => {
      const tl = onLeave(el)
      await tl.play()
      window.lenis.scrollTo(0, { immediate: true })
      done()
    },
  },
})

// Ottieni la configurazione dal tuo store personalizzato
const { configuration } = useCraftStore()
const route = useRoute()
const { t } = useI18n()

const selectedCategories = ref(route.query?.categories || [])

// Fetch Data
const query = queries.finishings.getFinishings

const limit = ref(32)

const variables = computed(() => ({
  site: configuration.site,
  limit: limit.value,
  finishingColorType: selectedCategories.value,
  offset: route.query?.page
    ? (parseInt(route.query?.page) - 1) * limit.value
    : 0,
}))
const { data } = await useGraphql(query, variables)

if (!data.value?.finishingsHomeEntries?.[0] || !data.value?.finishingsEntries) {
  throw createError({ statusCode: 404 })
}

const finishings = computed(() => data.value?.finishingsHomeEntries?.[0])
const list = computed(() => data.value.finishingsEntries)
const count = computed(() => data.value?.entryCount || 0)
const seo = computed(() => data.value?.finishingsHomeEntries?.[0]?.seo || {})

const familiesForFilters = finishesFilters.map((filter) => ({
  id: filter,
  title: t(`filters.${filter}`),
}))

// Quando seleziono un filtro
const onFilterSelected = (selected) => {
  selectedCategories.value = selected
}

// Seo
useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
